import i18n from '@/utils/i18n';
import React from 'react';
import { Badge, BadgeSize } from '@usepepper/ui/atoms/badge';
import { createStyles } from '@/contexts/theme-context';
import { IconHolder, Icons, Tooltip } from '@usepepper/sprout-kit-ui';
import { Pressable, StyleSheet, View } from 'react-native';

interface Props {
  activeCount: number;
  onPress: () => void;
}

export const PricingFilterButton: React.FC<Props> = ({
  activeCount,
  onPress,
}) => {
  const [styles, theme] = useStyles();

  return (
    <Tooltip offset={4} placement="bottom">
      <Tooltip.Trigger>
        <Pressable
          accessibilityLabel={i18n.t('pricing.filters.tooltip')}
          accessibilityRole="button"
          onPress={onPress}
          style={({ pressed, hovered }) =>
            StyleSheet.flatten([
              styles.trigger,
              (pressed || hovered) && styles.triggerActive,
            ])
          }
        >
          <IconHolder color={theme.sk.color.icon.secondary} size="$sm">
            <Icons.SlidersHorizontal />
          </IconHolder>
          {activeCount > 0 ? (
            <View style={styles.badgeWrapper}>
              <Badge
                label={String(activeCount)}
                size={BadgeSize.XSMALL}
                style={styles.badge}
                textStyle={styles.badgeText}
              />
            </View>
          ) : null}
        </Pressable>
      </Tooltip.Trigger>
      <Tooltip.Content>
        <Tooltip.Text>{i18n.t('pricing.filters.tooltip')}</Tooltip.Text>
      </Tooltip.Content>
    </Tooltip>
  );
};

const useStyles = createStyles((theme) => ({
  badge: {
    backgroundColor: theme.sk.color.bg.button.primary.default,
  },
  badgeText: {
    color: theme.sk.color.text.ondark,
  },
  badgeWrapper: {
    position: 'absolute',
    right: -theme.sk.spacing.spaceSmall,
    top: -theme.sk.spacing.spaceSmall,
  },
  trigger: {
    alignItems: 'center',
    backgroundColor: theme.sk.color.bg.button.secondary.default,
    borderRadius: theme.sk.radii.radiusMedium,
    height: theme.sk.spacing.space2xlarge,
    justifyContent: 'center',
    marginLeft: theme.sk.spacing.spaceSmall,
    position: 'relative',
    width: theme.sk.spacing.space2xlarge,
  },
  triggerActive: {
    backgroundColor: theme.sk.color.bg.button.secondary.hover,
  },
}));
